import { withCompInfo } from '@wix/editor-elements-integrations'
import type { TextMarqueeDefinition, TextMarqueeProps } from './TextMarquee'
import type { ParsedSvg } from '@wix/thunderbolt-commons'

export const props = withCompInfo<TextMarqueeProps, TextMarqueeDefinition>()(['compData'], ({ compData }) => {
	const { svgId: svg, items } = compData as any
	const { info: svgInfo, content: svgString } = (svg as unknown) as ParsedSvg

	const resolvedItems = items.map((item: any) => {
		const itemLink = item.link
		return {
			text: item.text,
			resolvedLink: itemLink,
		}
	})

	return {
		svgInfo,
		svgString,
		resolvedItems,
	}
})
